import React from 'react';
import { typography } from '../../styles/typography';
import {
  LOST_FOUND_STATUS,
  getLocationFieldLabels,
  getStatusLabel,
} from './lostAndFoundData';

const STATUS_STYLES = {
  [LOST_FOUND_STATUS.LOST]: 'bg-amber-50 text-amber-800 border-amber-200',
  [LOST_FOUND_STATUS.FOUND]: 'bg-blue-50 text-blue-800 border-blue-200',
  [LOST_FOUND_STATUS.COLLECTED]: 'bg-green-50 text-green-800 border-green-200',
};

const LostAndFoundItemSummary = ({ item }) => {
  if (!item) return null;

  const { locationLabel, handoffLabel } = getLocationFieldLabels(item.status);

  return (
    <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-start">
      <div className="w-full md:w-2/5 md:max-w-xs shrink-0 flex flex-col gap-2">
        <span className="text-sm font-medium text-gray-500 font-['Open_Sans']">Image</span>
        {item.image_url ? (
          <img
            src={item.image_url}
            alt={item.item_name}
            className="w-full aspect-square max-h-72 rounded-xl object-cover"
          />
        ) : (
          <div className="w-full aspect-square max-h-72 rounded-xl bg-gray-100 flex items-center justify-center text-sm text-gray-400 font-['Open_Sans'] text-center px-4">
            No image uploaded
          </div>
        )}
      </div>

      <div className="flex-1 flex flex-col gap-4 min-w-0">
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium text-gray-500 font-['Open_Sans']">Item name</span>
          <p className={`${typography.h3} text-black font-['Open_Sans']`}>{item.item_name}</p>
          <span
            className={`self-start inline-flex px-2.5 py-1 rounded-lg text-xs font-medium border font-['Open_Sans'] ${
              STATUS_STYLES[item.status] || 'bg-gray-50 text-gray-700 border-gray-200'
            }`}
          >
            {getStatusLabel(item.status)}
          </span>
        </div>

        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium text-gray-500 font-['Open_Sans']">
            {locationLabel}
          </span>
          <p className="text-base text-black font-['Open_Sans']">{item.location || '—'}</p>
        </div>

        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium text-gray-500 font-['Open_Sans']">
            {handoffLabel}
          </span>
          <p className="text-base text-black font-['Open_Sans']">
            {item.submit_collect_at || '—'}
          </p>
        </div>

        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium text-gray-500 font-['Open_Sans']">Description</span>
          <p className="text-base text-black font-['Open_Sans'] whitespace-pre-wrap">
            {item.description || '—'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LostAndFoundItemSummary;
